<template>
  <div style="width: 100%;height: 100%">
    <!-- 订单Title -->
    <V-DSOrderDetailTitleData :title-data="titleData[0]"></V-DSOrderDetailTitleData>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" min-width="30"></el-table-column>
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="名称" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="GYS_PRICE" label="采购价"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税采购价"></el-table-column>
          <el-table-column prop="PROJECT_SALE_PRICE" label="销售价"></el-table-column>
          <el-table-column prop="PROJECT_SALE_PRICE_BEFORE_TAX" label="不含税销售价">
            <template slot-scope="scope">
              <span>{{ Number(scope.row.PROJECT_SALE_PRICE_BEFORE_TAX).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column label="送货数量" prop="NEED_COUNT">
            <template slot-scope="scope">
              <el-input size="small" style="width:100%" v-model="scope.row.NEED_COUNT" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="采购总金额"></el-table-column>
          <el-table-column prop="PRODUCT_FEE_BEFORE_TAX" label="不含税采购总金额"></el-table-column>
          <el-table-column prop="销售总金额" label="销售总金额"></el-table-column>
          <el-table-column prop="不含税销售总金额" label="不含税销售总金额"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editProduct(scope.row)" v-if="userPriceType == 1">
                修改
              </el-button>
              <el-button size="small" type="text" @click="editProductSpecial(scope.row)" v-else>修改</el-button>
              <el-button v-show="scope.row.BATCH_REPORT_ID !== 0" size="small" type="text"
                @click="downloadBatch(scope.row.BATCH_REPORT_ID)">
                查询批次报告
              </el-button>
              <el-button size="small" type="text" @click="删除(scope.row)" v-show="fun_dic[101010103]">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div slot="footer" style="display: flex; margin-top: 10px;"
      :style="{ 'justify-content': fun_dic[101010104] ? 'space-between' : 'flex-end' }">
      <el-button type="primary" size="medium" @click="reconvert" v-show="fun_dic[101010104]">重新转换第三方</el-button>
      <el-button type="primary" size="medium" @click="submintEdit">更新送货数量</el-button>
    </div>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <el-dialog title="修改" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
      <el-radio-group v-model="radio" style="display:block;text-align:center;margin-bottom:30px" @change="priceORfee">
        <el-radio label="1">按总额修改</el-radio>
        <el-radio label="2">按数量修改</el-radio>
      </el-radio-group>
      <el-form size="small" :model="editForm" ref="editForm">
        <el-form-item label="产品名称：" label-width="120px">
          <span>{{ this.editForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：" label-width="120px">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.editForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="实收数量：" label-width="120px">
          <el-input v-model="editForm.REAL_COUNT" @change="RealCount" @input="countFee"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="单价：" label-width="120px">
          <el-input v-model="editForm.GYS_PRICE" @change="GysPrice" @input="countFee" :disabled="isdisabledPrice"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="不含税单价：" label-width="120px">
          <el-input v-model="editForm.BEFORE_TAX_PRICE" disabled></el-input>
        </el-form-item>
        <el-form-item label="总金额：" label-width="120px">
          <el-input v-model="editForm.TOTAL_FEE" @change="TotalFee" @input="changePrice" :disabled="isdisabledFee"
            oninput="value=value.replace(/[^0-9.]/g,'')">
          </el-input>
        </el-form-item>
        <el-form-item label="不含税总金额：" label-width="120px">
          <el-input v-model="editForm.PRODUCT_FEE_BEFORE_TAX" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注：" label-width="120px">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input v-model="editForm.PRODUCT_COMMENT" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="修改数量类型：" label-width="120px">
          <el-radio-group v-model="editForm.typeRadio">
            <el-radio label="0">修改实收数量</el-radio>
            <el-radio label="1">修改产品数量和实收数量</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" @click="editSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="specialEditFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="specialEditForm" ref="specialEditForm" size="small" :rules="rules" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ this.specialEditForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.specialEditForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="采购价：" prop="REAL_PRICE">
          <label slot="label">采&nbsp;&nbsp;购&nbsp;&nbsp;价：</label>
          <el-input v-model="specialEditForm.REAL_PRICE" @input="specialEditRealPriceInput"></el-input>
        </el-form-item>
        <el-form-item label="不含税采购价：" prop="BEFORE_TAX_PRICE">
          <el-input v-model="specialEditForm.BEFORE_TAX_PRICE" disabled></el-input>
        </el-form-item>
        <el-form-item label="销售价：" prop="销售价" v-show="fun_dic[101010102]">
          <label slot="label">销&nbsp;&nbsp;售&nbsp;&nbsp;价：</label>
          <el-input v-model="specialEditForm.销售价" @change="修改销售价()"></el-input>
        </el-form-item>
        <el-form-item label="实收数量：" prop="REAL_COUNT">
          <el-input v-model="specialEditForm.REAL_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="specialEditFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitEdit('specialEditForm')" :loading="loading1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 更新历史价格 -->
    <el-dialog title="历史价格更新" center :visible.sync="updateHistoryPriceFormVisible" width="400px"
      :close-on-click-modal="false">
      <el-form :model="updateHistoryPriceForm" size="small">
        <el-form-item label="单价：" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
          <el-input v-model="updateHistoryPriceForm.PRICE"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateHistoryPriceFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitHistoryPrice">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="以下产品重新转换失败" :visible.sync="errDialog" width="600px" :close-on-click-modal="false">
      <el-table :data="errData" border stripe style="width: 100%">
        <el-table-column label="订单详情ID" prop="ORDER_DETAIL_ID"></el-table-column>
        <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
        <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
        <el-table-column label="失败原因" prop="ERR_MESSAGE"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  newHistoryOrderDetailFun, modifyOrderFun, updateHistoryPrice, downloadBatchReport,
} from 'api/shopOrderManage';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import VDSOrderDetailTitleData from '../DSOrder/DSOrderDetailTitleData';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['DSOrder'],
      toName: [],
      PAGE_ID: '1010101', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        101010101: 0, 101010102: 0, 101010103: 0, 101010104: 0,
      },
      managername: '',
      tableData: [],
      // loading: false,
      titleData: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      editFormVisible: false,
      editForm: {},
      printStatus: '',
      formLabelWidth: '150px',
      orderID: Number(sessionStorage.getItem('orderId')),
      CAN_MODIFY_PRICE: '',
      isdisabledPrice: false,
      isdisabledFee: false,
      radio: '1',
      statusFlag: 0,
      checkData: [],
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      specialEditFormVisible: false,
      specialEditForm: {},
      rules: {
        REAL_PRICE: [
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        REAL_COUNT: [
          { required: true, message: '请输入实收数量', trigger: 'blur' },
        ],
      },
      loading1: false,
      updateHistoryPriceFormVisible: false,
      updateHistoryPriceForm: {},
      selectedRows: [],
      errDialog: false,
      errData: [],
      isQueryAfterConvert: false,
    };
  },
  components: {
    VDSOrderDetailTitleData,
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    reconvert() {
      if (this.selectedRows.length === 0) {
        this.$message.show({ text: '请选择需要重新转换的订单', type: 'warning' });
        return false;
      }
      this.$confirm('按当前第三方关系重新转换成功后，会删除当前选择的订单数据，确认继续转换吗？', '提示', {
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10179',
          OTYPE: 17,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          ORDER_ID: this.orderID,
          DETAIL_LIST: this.selectedRows.map(({ ID }) => ID),
        };
        http.post(params).then((res) => {
          if (res[0]) {
            if (res[0].ERR_MESSAGE) this.$message.show({ text: res[0].ERR_MESSAGE, type: 'success' });
            else if (res[0].ERR_LIST) {
              this.errDialog = true;
              this.errData = res[0].ERR_LIST;
            } else {
              this.$message.show({ text: '重新转换成功', type: 'success' });
            }
          }
          this.isQueryAfterConvert = true;
          this.selectedRows = [];
          this.queryOrderDetailListData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ text: '已取消', type: 'info' });
      });
    },
    handleSelectionChange(e) {
      this.selectedRows = e;
    },
    priceORfee(val) {
      if (Number(this.CAN_MODIFY_PRICE) !== 1) {
        this.isdisabledPrice = true;
        this.isdisabledFee = true;
      } else if (Number(this.radio) === 1) {
        this.isdisabledPrice = true;
        this.isdisabledFee = false;
      } else if (Number(this.radio) === 2) {
        this.isdisabledPrice = false;
        this.isdisabledFee = true;
      }
    },
    submintEdit() {
      const submitArr = this.tableData.map((item, index) => ({
        ORDER_DETAIL_ID: Number(item.ID),
        PRODUCT_CODE: item.PRODUCT_CODE,
        NEED_COUNT: Number(item.NEED_COUNT),
        PRODUCT_FEE: Number(item.TOTAL_FEE),
      }));
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.orderID,
        PRODUCT_ARRAY: submitArr,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    editProduct(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.editFormVisible = true;
      this.editForm = { ...row };
    },
    ProductCount(e) {
      this.editForm.PRODUCT_COUNT = e;
    },
    RealCount(e) {
      this.editForm.REAL_COUNT = e;
    },
    GysPrice(e) {
      this.editForm.GYS_PRICE = e;
    },
    TotalFee(e) {
      this.editForm.TOTAL_FEE = e;
    },
    editSubmit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!validation.价格正数0验证(this.editForm.GYS_PRICE)) {
            this.$message.show({ text: '请输入正确的价格', type: 'warning' });
            return;
          }
          const params = {
            SERVICE_ID: '10003',
            OTYPE: 40,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRODUCT_CODE: Number(this.editForm.PRODUCT_CODE),
            ORDER_ID: this.orderID,
            ORDER_DETAIL_ID: this.editForm.ID,
            NEW_COUNT: Number(this.editForm.REAL_COUNT),
            PRICE: this.editForm.GYS_PRICE,
            PRODUCT_FEE: Number(this.editForm.TOTAL_FEE),
            BEFORE_TAX_PRICE: Number(this.editForm.BEFORE_TAX_PRICE),
            TAX_RATE: Number(this.editForm.TAX_RATE),
          };
          if (this.editForm.PRODUCT_COMMENT) {
            params.PRODUCT_COMMENT = this.editForm.PRODUCT_COMMENT;
          }
          if (this.editForm.typeRadio) {
            params.MODIFY_REAL_FLAG = Number(this.editForm.typeRadio);
          }


          for (const key in params) {
            if ([null, undefined, Infinity, NaN].includes(params[key])) {
              this.$message.show({ text: '请输入正确的数', type: 'warning' });
              return false;
            }
          }


          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.queryOrderDetailListData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // -----------------------------------进入页面拉取数据
    queryOrderDetailListData() {
      const params = {
        ID: this.orderID,
      };
      newHistoryOrderDetailFun(params).then((result) => {
        if (result) {
          if (result[0].bottom.length !== 0 && result[0].list.length !== 0 && result[0].title.length !== 0) {
            const {
              ORDER_ID, SEND_DATE, CUSTOMER_NAME, PROJECT_NAME, DK_NAME, TOTAL_FEE,
            } = JSON.parse(sessionStorage.getItem('DSOrderDetailTitle'));
            this.titleData = result[0].title.map((item) => ({
              ...item,
              ORDER_ID,
              ORDER_CODE: item.ORDER_CODE,
              SEND_DATE,
              TOTAL_FEE,
              SUPPLIER_NAME: item.SUPPLIER_NAME,
              CUSTOMER_NAME,
              PROJECT_NAME,
              DK_NAME,
            }));
            this.tableData = result[0].list.map((item) => ({
              ...item,
              TOTAL_FEE: item.TOTAL_FEE.toFixed(2),
              BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
              NEW_BEFORE_TAX_PRICE: Number((item.REAL_PRICE / (1 + item.TAX_RATE / 100)).toFixed(10)),
              销售总金额: Number(item.PROJECT_SALE_PRICE * item.PRODUCT_COUNT).toFixed(2),
              不含税销售总金额: Number(item.PROJECT_SALE_PRICE_BEFORE_TAX * item.PRODUCT_COUNT).toFixed(2),
            }));
            this.managername = result[0].bottom[0].CONTACT_NAME;
            this.CAN_MODIFY_PRICE = result[0].modify_flag;
            this.checkData = result[0].OR ? result[0].OR[0].DATA : [];
            this.statusFlag = result[0].OR ? result[0].OR[0].RN : 0;
            this.priceORfee();
          } else {
            this.tableData = [];
          }
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        if (this.isQueryAfterConvert && this.tableData.length == 0) {
          this.$router.back();
        }
        this.isQueryAfterConvert = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    changePrice() {
      if (Number(this.radio) === 1) {
        this.editForm.GYS_PRICE = (Math.round((this.editForm.TOTAL_FEE / this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.PRODUCT_FEE_BEFORE_TAX = (Math.round((Number(this.editForm.TOTAL_FEE) / (1 + this.editForm.TAX_RATE / 100)) * 100) / 100).toFixed(2);
        this.editForm.NEW_BEFORE_TAX_PRICE = Number(((this.editForm.TOTAL_FEE / (1 + this.editForm.TAX_RATE / 100)) / this.editForm.REAL_COUNT).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
      }
    },
    countFee() {
      if (Number(this.radio) === 1) {
        this.editForm.GYS_PRICE = (Math.round((this.editForm.TOTAL_FEE / this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.NEW_BEFORE_TAX_PRICE = Number(((this.editForm.TOTAL_FEE / (1 + this.editForm.TAX_RATE / 100)) / this.editForm.REAL_COUNT).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
      } else if (Number(this.radio) === 2) {
        this.editForm.NEW_BEFORE_TAX_PRICE = Number((this.editForm.GYS_PRICE / (1 + this.editForm.TAX_RATE / 100)).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
        this.editForm.TOTAL_FEE = (Math.round((this.editForm.GYS_PRICE * this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.PRODUCT_FEE_BEFORE_TAX = (Math.round((Number(this.editForm.GYS_PRICE * this.editForm.REAL_COUNT) / (1 + this.editForm.TAX_RATE / 100)) * 100) / 100).toFixed(2);
      }
    },
    editProductSpecial(row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.specialEditFormVisible = true;
      this.specialEditForm = { ...row, 销售价: row.PROJECT_SALE_PRICE };
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.specialEditForm.REAL_COUNT)) {
            this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
            return false;
          }
          if (!util.JudgmentUnit(this.specialEditForm.TYPE_UNIT)) { // 如果不是
            const beInter = (this.specialEditForm.REAL_COUNT % 1 === 0);
            if (beInter == false) {
              this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
              return false;
            }
          }
          if (!validation.价格正数验证(this.specialEditForm.REAL_PRICE)) {
            this.$message.show({ text: '请输入正确的采购价', type: 'warning' });
            return false;
          }
          const updateParams = {
            ORDER_DETAIL_ID: Number(this.specialEditForm.ID),
            ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_COUNT: Number(this.specialEditForm.REAL_COUNT),
            PRICE: this.specialEditForm.REAL_PRICE,
            PRODUCT_COMMENT: this.specialEditForm.PRODUCT_COMMENT,
            PRICE_MODE: this.userPriceType,
            BEFORE_TAX_PRICE: this.specialEditForm.NEW_BEFORE_TAX_PRICE,
            TAX_RATE: this.specialEditForm.TAX_RATE,
          };
          if (this.specialEditForm.销售价 != this.specialEditForm.PROJECT_SALE_PRICE) {
            if (!validation.价格正数验证(this.specialEditForm.销售价)) {
              this.$message.show({ text: '请输入正确的销售价', type: 'warning' });
              return false;
            }
            updateParams.SALE_DETAIL_ID = this.specialEditForm.SALE_DETAIL_ID;
            updateParams.PROJECT_SALE_PRICE = this.specialEditForm.销售价;
          }
          this.loading1 = true;
          modifyOrderFun(updateParams)
            .then((result) => {
              this.$message.show({ text: '修改成功', type: 'success' });
              this.loading1 = false;
              this.editPriceFormVisible = false;
              this.specialEditFormVisible = false;
              this.queryOrderDetailListData();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.loading1 = false;
            });
        } else {
          return false;
        }
      });
    },
    // 更新历史价格
    updateHistoryPrice(row) {
      this.updateHistoryPriceForm = row;
      this.updateHistoryPriceFormVisible = true;
    },
    submitHistoryPrice() {
      if (!validation.价格正数验证(this.updateHistoryPriceForm.PRICE)) {
        this.$message.show({ text: '请输入正数单价', type: 'warning' });
        return false;
      }
      const updateParams = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRICE: Number(this.updateHistoryPriceForm.PRICE),
        PRODUCT_CODE: Number(this.updateHistoryPriceForm.PRODUCT_CODE),
        TYPE_UNIT: this.updateHistoryPriceForm.TYPE_UNIT,
        DETAIL_ID: Number(this.updateHistoryPriceForm.ID),
      };
      updateHistoryPrice(updateParams)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.updateHistoryPriceFormVisible = false;
          this.updateHistoryPriceForm = {};
          this.queryOrderDetailListData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    specialEditRealPriceInput(val) {
      val = val.replace(/[^0-9]*/, '');
      this.specialEditForm.NEW_BEFORE_TAX_PRICE = Number((val / (1 + this.specialEditForm.TAX_RATE / 100)).toFixed(10));
      this.specialEditForm.BEFORE_TAX_PRICE = this.specialEditForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
    },
    修改销售价(val) {
      if (!validation.价格正数验证(this.specialEditForm.销售价)) {
        this.$message.show({ text: '请输入正确的销售价', type: 'warning' });
      }
    },
    删除(row) {
      this.$confirm('确认删除该商品吗？').then(() => {
        const params = {
          SERVICE_ID: '10179',
          OTYPE: 88,
          PURCHASE_ORDER_DETAIL_ID: row.ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryOrderDetailListData();
          if (this.tableData == []) {
            this.$message.show({ text: '订单已删除，返回到待送订单列表', type: 'success' });
            this.$router.push({ name: 'DSOrder' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ text: '取消操作', type: 'info' });
      });
    },
    downloadBatch(BATCH_REPORT_ID) {
      const params = {
        BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((result) => {
        window.open(this.$util.getURLLocalHost(result[0].FILE_PATH), 'file');
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待送订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryBeforeFun();
        that.queryOrderDetailListData();
      }
    });
  },
};
</script>
<style scoped>
  .ma img {
    width: 105px;
  }

  ul {
    list-style: none;
    min-height: 75px;
    padding: 0;
  }

  li {
    margin-bottom: 0;
    line-height: 25px;
    font-size: 14px;
  }

  p {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSOrderDetail.vue